module.exports = __webpack_public_path__ + "media/step3_animation.f7513139.webm";